import { render, staticRenderFns } from "./TrainingProgramDetails.vue?vue&type=template&id=6ff2eb55&scoped=true&"
import script from "./TrainingProgramDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingProgramDetails.vue?vue&type=script&lang=js&"
import style0 from "./TrainingProgramDetails.vue?vue&type=style&index=0&id=6ff2eb55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2eb55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
